import { faCheckSquare } from '@fortawesome/pro-solid-svg-icons';

import './Style.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type CheckboxItemProps = {
  onAddSelectedItem: (item: any) => void;
  item: any;
  checked: boolean;
  secondaryQ: boolean;
};

export function CheckboxItem({ onAddSelectedItem, item, checked, secondaryQ }: CheckboxItemProps) {
  function setCheckedHandler(event: React.ChangeEvent<HTMLInputElement>) {
    const newItem = {
      add: event.target.checked,
      id: event.target.id,
      title: event.target.title,
      class: '',
    };

    onAddSelectedItem(newItem);
  }

  return (
    <div className="checkbox_item">
      <input
        type="checkbox"
        id={secondaryQ ? `${item.id}_sq` : item.id}
        name={secondaryQ ? `${item.id}_sq` : item.id}
        className="fdatacollect"
        onChange={setCheckedHandler}
        title={item.title}
        checked={checked}
      />
      <label
        htmlFor={secondaryQ ? `${item.id}_sq` : item.id}
        id={`${item.title.replace(/\s+/g, '_')}_label`}
      >
        <FontAwesomeIcon icon={faCheckSquare} className="icon" />
        {item.title}
      </label>
    </div>
  );
}
